var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',[(_vm.formData.fields)?_c('div',{staticClass:"row"},_vm._l((_vm.orderedFields),function(field){return _c('base-field',{key:field.field_id,ref:"baseFields",refInFor:true,attrs:{"field":field,"person-number":1,"form-data":_vm.formData},on:{"blur":_vm.onBlur}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }